/**
 * Utility functions for the frontend
 */

import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Combines class names using clsx and tailwind-merge
 * This allows for conditional classes and proper Tailwind class merging
 * 
 * Example:
 * cn('px-4 py-2', condition && 'bg-red-500', 'text-white')
 * cn('p-4', className) // merges user className with defaults
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

